import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * A custom element that displays a product disclaimer.
 * Listens for variant update events on PDP and updates content.
 */
class ProductDisclaimer extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog, [id*="ProductInformation-"]');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateDisclaimer);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog, [id*="ProductInformation-"]');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateDisclaimer);
  }

  /**
   * Updates the product disclaimer on variant change.
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  updateDisclaimer = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newDisclaimer = event.detail.data.html.querySelector('product-disclaimer');

    if (!newDisclaimer) return;

    morph(this, newDisclaimer);
  };
}

if (!customElements.get('product-disclaimer')) {
  customElements.define('product-disclaimer', ProductDisclaimer);
}
